import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { get, MICROSERVICES } from 'api';
import { IOperation, IResource } from 'interfaces/Permission';
import { IMyKnownError, REQUEST_LIFE_CICLE } from 'interfaces/requests';
import { openAlertToUserLogoutAction } from 'modules/user';

import endpoints from './endpoints';
import { IPermissionListState } from './interfaces';

export const listResourcesAction = createAsyncThunk<
  IResource[],
  undefined,
  { rejectValue: IMyKnownError }
>('listResources', async (payload, { dispatch, rejectWithValue }) => {
  try {
    const result = await get<IResource[]>(MICROSERVICES.AUTH, {
      url: endpoints.listResources(),
      params: payload,
    });
    return result.data;
  } catch (error) {
    dispatch(openAlertToUserLogoutAction());
    return rejectWithValue(error);
  }
});

export const listOperationsAction = createAsyncThunk<
  IOperation[],
  undefined,
  { rejectValue: IMyKnownError }
>('listOperations', async (payload, { dispatch, rejectWithValue }) => {
  try {
    const result = await get<IOperation[]>(MICROSERVICES.AUTH, {
      url: endpoints.listOperations(),
      params: payload,
    });
    return result.data;
  } catch (error) {
    dispatch(openAlertToUserLogoutAction());
    return rejectWithValue(error);
  }
});

const initialState: IPermissionListState = {
  loadingResources: REQUEST_LIFE_CICLE.IDLE,
  loadingOperations: REQUEST_LIFE_CICLE.IDLE,
  errorMessage: '',
  resources: [],
  operations: [],
};

const permissionsListSlice = createSlice({
  name: 'permissionsList',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(listResourcesAction.fulfilled, (state, action) => {
      state.loadingResources = REQUEST_LIFE_CICLE.SUCCEEDED;
      state.errorMessage = '';
      state.resources = action.payload;
    });
    builder.addCase(listResourcesAction.pending, (state) => {
      state.loadingResources = REQUEST_LIFE_CICLE.PENDING;
    });
    builder.addCase(listResourcesAction.rejected, (state, action) => {
      state.loadingResources = REQUEST_LIFE_CICLE.FAILED;
      state.errorMessage = action.payload?.message || 'Erro no servidor';
    });

    builder.addCase(listOperationsAction.fulfilled, (state, action) => {
      state.loadingOperations = REQUEST_LIFE_CICLE.SUCCEEDED;
      state.errorMessage = '';
      state.operations = action.payload;
    });
    builder.addCase(listOperationsAction.pending, (state) => {
      state.loadingOperations = REQUEST_LIFE_CICLE.PENDING;
    });
    builder.addCase(listOperationsAction.rejected, (state, action) => {
      state.loadingOperations = REQUEST_LIFE_CICLE.FAILED;
      state.errorMessage = action.payload?.message || 'Erro no servidor';
    });
  },
});

const { reducer } = permissionsListSlice;
export default reducer;
